import { useEffect } from 'react';
import { last } from 'lodash-es';
import { ROLE } from 'site-modules/canvas/constants/canvas';
import { usePrevious } from 'client/site-modules/shared/hooks/use-previous';

export function useChatScroll({ isChatInProgress, scrollStrategy, messages }) {
  const previousMessages = usePrevious(messages);

  useEffect(() => {
    if (!messages) {
      return;
    }

    const userMessages = messages.filter(message => message.role === ROLE.USER);

    if (!userMessages.length) {
      return;
    }

    if (previousMessages?.includes(last(userMessages))) {
      return;
    }

    const lastMessage = last(messages);
    const lastMessageElement = last(scrollStrategy.getMessagesElement()?.querySelectorAll('.user-message'));

    // Submit scenario. New user message appeared with AI message placeholder. Scroll to the last user message.
    if (lastMessage.responsePromise) {
      scrollStrategy.scrollToElement(lastMessageElement, true);

      return;
    }

    // History scenario. Scroll to the last user message.
    scrollStrategy.scrollToElement(lastMessageElement);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  useEffect(() => {
    if (!isChatInProgress) {
      scrollStrategy.resetScroll();
    }
  }, [isChatInProgress, scrollStrategy]);
}
